import ipadusersService from "../../services/ipadusers.service";

const state = {
    userList: [],
    user: [],
    isActiveModal: false,
};

const mutations = {

    set_user_list(state, payload) {
        state.userList = payload
    },

    clear_user_list(state)
    {
        state.userList = []
    },

    set_user(state, payload) {
        state.user = payload;
    },

    set_close_open_modal(state) {
        state.isActiveModal = !state.isActiveModal
    },

    set_clear_airport(state) {
        state.user = [];
    }

};

const actions = {

    async getipadUsers({commit}) {

        commit("clear_user_list");
        const users = await ipadusersService.getUsers();
        //console.log("getipadUsers devreye girdi !");
        commit("set_user_list", users);
        return users;
    },

    async getipadUser({commit},payload) {
        const  user = await ipadusersService.getUser(payload);
        await  commit("set_user",user);
        return user;
    },

    async UpdateipadUser({dispatch}, payload) {
        const user = await ipadusersService.updateUsers(payload);
        dispatch("getipadUsers");
        return user
    },

    async AddipadUser({dispatch}, payload) {
        //console.log(" before add "+payload);
        const user = await ipadusersService.addUsers(payload);
        //console.log(" after add "+user);
        dispatch("getipadUsers");
        return user
    },

    async openCloseIpadUserModal({commit}) {
        await commit("set_close_open_modal");
        await commit("set_clear_airport");
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
